import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "List of accounts", -1)
const _hoisted_2 = { class: "table" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Customer Id"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("p", null, [
      _createVNode(_component_RouterLink, { to: { name: 'accounts-create' } }, {
        default: _withCtx(() => [
          _createTextVNode("Create new")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountsStore.accounts, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.id
          }, [
            _createElementVNode("td", null, _toDisplayString(item.id), 1),
            _createElementVNode("td", null, _toDisplayString(item.customerId), 1),
            _createElementVNode("td", null, [
              _createVNode(_component_RouterLink, {
                to: { name: 'accounts-details', params: { id: item.id } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Details")
                ]),
                _: 2
              }, 1032, ["to"]),
              _createTextVNode(" | "),
              _createVNode(_component_RouterLink, {
                to: { name: 'accounts-edit', params: { id: item.id } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Edit")
                ]),
                _: 2
              }, 1032, ["to"]),
              _createTextVNode(" | "),
              _createVNode(_component_RouterLink, {
                to: { name: 'accounts-delete', params: { id: item.id } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Delete")
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}